<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <b-card class="mb-2 shadow mx-2 bg-light">
      <b-card-group deck v-if="loaded">
        <b-card
          no-body
          v-for="(card, cardIndex) in cards"
          class="shadow"
          :key="cardIndex"
        >
          <b-card-header
            ><h6>{{ card.title }}</h6></b-card-header
          >
          <b-list-group>
            <b-list-group-item
              class="d-flex  align-items-center"
              :to="item.to ? item.to : ''"
              v-for="(item, itemIndex) in card.list"
              :key="itemIndex"
              ><div
                
                v-if="item.icon"
                v-html="item.icon"
                class="mr-3"
              ></div>
              <div>{{ item.title }}</div>
              <div class="ml-auto">
                <b-badge v-if="item.total !== null" variant="info" pill>{{
                  item.total
                }}</b-badge>
                <b-icon v-else icon="arrow-clockwise" animation="spin"></b-icon>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-card-group>
    </b-card>
  </div>
</template>

<script>
// @ is an alias to /src
import gestion from "@/services/gestion.js";
export default {
  name: "Home",
  components: {},
  methods: {
    load() {
      gestion.overview("no").then((response) => {
        if (response.data.success) {
          this.cards = response.data.data;
          this.loaded = true;
          this.loadWithSql();
        }
      });
    },
    loadWithSql() {
      gestion.overview("yes").then((response) => {
        if (response.data.success) {
          this.cards = response.data.data;
        }
      });
    },
  },
  created() {
    this.load();
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      cards: [],
      loaded: false,
      items: [
        {
          text: "Gestion",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>